"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberedList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const bulletDiameter = '20px';
const StyledOL = styled_1.default.ol `
	padding-left: 0;
	list-style: none;
	counter-reset: list-counter;

	li {
		position: relative;
		counter-increment: list-counter;
		margin: ${merlin_theme_1.default.layout.spacing.smaller} 0;
		padding-left: calc(${merlin_theme_1.default.layout.spacing.smaller} + ${bulletDiameter});
	}

	li::before {
		content: counter(list-counter);
		position: absolute;
		left: 0px;
		top: 50%;
		transform: translateY(-50%);

		text-align: center;
		width: ${bulletDiameter};
		display: flex;
		align-items: center;
		justify-content: center;
		height: ${bulletDiameter};
		color: ${merlin_theme_1.default.colours.text.white};
		background-color: ${merlin_theme_1.default.palette.greyscale.darker};
		border-radius: 50%;
	}
`;
const NumberedList = (props) => React.createElement(StyledOL, Object.assign({}, props), props.list.map((item, index) => React.createElement("li", { key: index + 1 }, item)));
exports.NumberedList = NumberedList;
//# sourceMappingURL=NumberedList.js.map